/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { GenericBenefit } from './GenericBenefit';
import {
    GenericBenefitFromJSON,
    GenericBenefitFromJSONTyped,
    GenericBenefitToJSON,
    GenericBenefitToJSONTyped,
} from './GenericBenefit';
import type { RequestError } from './RequestError';
import {
    RequestErrorFromJSON,
    RequestErrorFromJSONTyped,
    RequestErrorToJSON,
    RequestErrorToJSONTyped,
} from './RequestError';
import type { Pharmacy } from './Pharmacy';
import {
    PharmacyFromJSON,
    PharmacyFromJSONTyped,
    PharmacyToJSON,
    PharmacyToJSONTyped,
} from './Pharmacy';
import type { ProcedureSection } from './ProcedureSection';
import {
    ProcedureSectionFromJSON,
    ProcedureSectionFromJSONTyped,
    ProcedureSectionToJSON,
    ProcedureSectionToJSONTyped,
} from './ProcedureSection';
import type { ActiveCoverage } from './ActiveCoverage';
import {
    ActiveCoverageFromJSON,
    ActiveCoverageFromJSONTyped,
    ActiveCoverageToJSON,
    ActiveCoverageToJSONTyped,
} from './ActiveCoverage';
import type { HospitalSnfStays } from './HospitalSnfStays';
import {
    HospitalSnfStaysFromJSON,
    HospitalSnfStaysFromJSONTyped,
    HospitalSnfStaysToJSON,
    HospitalSnfStaysToJSONTyped,
} from './HospitalSnfStays';
import type { RequestInfo } from './RequestInfo';
import {
    RequestInfoFromJSON,
    RequestInfoFromJSONTyped,
    RequestInfoToJSON,
    RequestInfoToJSONTyped,
} from './RequestInfo';
import type { PrimaryCareProvider } from './PrimaryCareProvider';
import {
    PrimaryCareProviderFromJSON,
    PrimaryCareProviderFromJSONTyped,
    PrimaryCareProviderToJSON,
    PrimaryCareProviderToJSONTyped,
} from './PrimaryCareProvider';
import type { ServiceTypeDetails } from './ServiceTypeDetails';
import {
    ServiceTypeDetailsFromJSON,
    ServiceTypeDetailsFromJSONTyped,
    ServiceTypeDetailsToJSON,
    ServiceTypeDetailsToJSONTyped,
} from './ServiceTypeDetails';
import type { InactiveCoverageDetection } from './InactiveCoverageDetection';
import {
    InactiveCoverageDetectionFromJSON,
    InactiveCoverageDetectionFromJSONTyped,
    InactiveCoverageDetectionToJSON,
    InactiveCoverageDetectionToJSONTyped,
} from './InactiveCoverageDetection';

/**
 * 
 * @export
 * @interface ExacareEligibilityResponse
 */
export interface ExacareEligibilityResponse {
    /**
     * 
     */
    check_id?: string;
    /**
     * 
     */
    date_executed?: Date;
    /**
     * 
     */
    request_hash?: string;
    /**
     * 
     */
    request_object?: object;
    /**
     * 
     */
    request_info?: RequestInfo;
    /**
     * 
     */
    active_coverage?: ActiveCoverage;
    /**
     *
     */
    inactive_coverage_detection?: InactiveCoverageDetection;
    /**
     * 
     */
    pharmacy?: Pharmacy;
    /**
     * 
     */
    primary_care_provider?: PrimaryCareProvider;
    /**
     * 
     */
    service_type_details?: Array<ServiceTypeDetails>;
    /**
     * 
     */
    benefit_information?: Array<GenericBenefit>;
    /**
     * 
     */
    hospital_snf_stays?: HospitalSnfStays;
    /**
     * 
     */
    preventative?: Array<ProcedureSection>;
    /**
     * 
     */
    covid?: Array<ProcedureSection>;
    /**
     * 
     */
    mco?: Array<GenericBenefit>;
    /**
     * 
     */
    home_health_hospice?: Array<GenericBenefit>;
    /**
     * 
     */
    errors?: Array<RequestError>;
}

/**
 * Check if a given object implements the ExacareEligibilityResponse interface.
 */
export function instanceOfExacareEligibilityResponse(value: object): value is ExacareEligibilityResponse {
    return true;
}

export function ExacareEligibilityResponseFromJSON(json: any): ExacareEligibilityResponse {
    return ExacareEligibilityResponseFromJSONTyped(json, false);
}

export function ExacareEligibilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExacareEligibilityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'check_id': json['check_id'] == null ? undefined : json['check_id'],
        'date_executed': json['date_executed'] == null ? undefined : (parseDate(json['date_executed'])),
        'request_hash': json['request_hash'] == null ? undefined : json['request_hash'],
        'request_object': json['request_object'] == null ? undefined : json['request_object'],
        'request_info': json['request_info'] == null ? undefined : RequestInfoFromJSON(json['request_info']),
        'active_coverage': json['active_coverage'] == null ? undefined : ActiveCoverageFromJSON(json['active_coverage']),
        'inactive_coverage_detection': json['inactive_coverage_detection'] == null ? undefined : InactiveCoverageDetectionFromJSON(json['inactive_coverage_detection']),
        'pharmacy': json['pharmacy'] == null ? undefined : PharmacyFromJSON(json['pharmacy']),
        'primary_care_provider': json['primary_care_provider'] == null ? undefined : PrimaryCareProviderFromJSON(json['primary_care_provider']),
        'service_type_details': json['service_type_details'] == null ? undefined : ((json['service_type_details'] as Array<any>).map(ServiceTypeDetailsFromJSON)),
        'benefit_information': json['benefit_information'] == null ? undefined : ((json['benefit_information'] as Array<any>).map(GenericBenefitFromJSON)),
        'hospital_snf_stays': json['hospital_snf_stays'] == null ? undefined : HospitalSnfStaysFromJSON(json['hospital_snf_stays']),
        'preventative': json['preventative'] == null ? undefined : ((json['preventative'] as Array<any>).map(ProcedureSectionFromJSON)),
        'covid': json['covid'] == null ? undefined : ((json['covid'] as Array<any>).map(ProcedureSectionFromJSON)),
        'mco': json['mco'] == null ? undefined : ((json['mco'] as Array<any>).map(GenericBenefitFromJSON)),
        'home_health_hospice': json['home_health_hospice'] == null ? undefined : ((json['home_health_hospice'] as Array<any>).map(GenericBenefitFromJSON)),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(RequestErrorFromJSON)),
    };
}

export function ExacareEligibilityResponseToJSON(json: any): ExacareEligibilityResponse {
    return ExacareEligibilityResponseToJSONTyped(json, false);
}

export function ExacareEligibilityResponseToJSONTyped(value?: ExacareEligibilityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'check_id': value['check_id'],
        'date_executed': value['date_executed'] == null ? value['date_executed'] : serializeDate(value['date_executed']),
        'request_hash': value['request_hash'],
        'request_object': value['request_object'],
        'request_info': RequestInfoToJSON(value['request_info']),
        'active_coverage': ActiveCoverageToJSON(value['active_coverage']),
        'inactive_coverage_detection': InactiveCoverageDetectionToJSON(value['inactive_coverage_detection']),
        'pharmacy': PharmacyToJSON(value['pharmacy']),
        'primary_care_provider': PrimaryCareProviderToJSON(value['primary_care_provider']),
        'service_type_details': value['service_type_details'] == null ? undefined : ((value['service_type_details'] as Array<any>).map(ServiceTypeDetailsToJSON)),
        'benefit_information': value['benefit_information'] == null ? undefined : ((value['benefit_information'] as Array<any>).map(GenericBenefitToJSON)),
        'hospital_snf_stays': HospitalSnfStaysToJSON(value['hospital_snf_stays']),
        'preventative': value['preventative'] == null ? undefined : ((value['preventative'] as Array<any>).map(ProcedureSectionToJSON)),
        'covid': value['covid'] == null ? undefined : ((value['covid'] as Array<any>).map(ProcedureSectionToJSON)),
        'mco': value['mco'] == null ? undefined : ((value['mco'] as Array<any>).map(GenericBenefitToJSON)),
        'home_health_hospice': value['home_health_hospice'] == null ? undefined : ((value['home_health_hospice'] as Array<any>).map(GenericBenefitToJSON)),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(RequestErrorToJSON)),
    };
}
